export default "__VITE_ASSET__610435c8__"